module.exports = __webpack_public_path__ + "static/media/contactbg.2c06bee8.png";